import { Component, OnInit, Input } from '@angular/core';
import { MgService } from 'src/app/services/mg.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-call-details',
  templateUrl: './call-details.component.html',
  styleUrls: [
    './call-details.component.scss',
    './../../../../assets/scss/call-screen.scss'
  ]
})
export class CallDetailsComponent implements OnInit {
  @Input() call: string;
  @Input() type: string;
  @Input() priority: string;
  @Input() status: string;
  @Input() operator: number;

  public users: User[];
  public _loading: boolean;

  constructor(
    private api: MgService
  ) { }

  ngOnInit(): void {
    this.listOperators();
  }

  private listOperators() {
    // this.users
    this.api.listUser()
      .subscribe(
        res => {
          this.users = res.data
        },
      )
  }

  public detailsChanged(): void {
    this.api.postCallDetails(
      this.call,
      {
        type: this.type,
        priority: this.priority,
        status: this.status,
        user: this.operator
      }
    )
      .toPromise()
      .catch(err => console.error(err));
  }

  public notifyOperator() {
    this.api.notifyUserOperator(this.call, this.operator)
      .toPromise()
      .catch(err => console.error(err));
  }

  public save() {
    this._loading = true;
    setTimeout(() => {
      this._loading = false;
    }, 2000)
  }
}
